<template>
	<el-col v-if="renderCol" v-bind="{xs, sm, md, lg, xl, ...$attrs}" class="col-inner">
		<slot />
	</el-col>
	<div v-else>
		<slot />
	</div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsCol',
	props: {
		xs: Number,
		sm: Number,
		md: Number,
		lg: Number,
		xl: Number,
		renderCol: { type: Boolean, default: true },
	},
});
</script>
